module.exports = __webpack_public_path__ + "static/media/fieldWithBannersNew.c4873aab.svg";